import { useState, useEffect } from "react";
import logo from "../../assets/logos/logo.png";
import logow from "../../assets/logos/logo.png";
import { DownOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import * as Components from "../";
import Logout from "../../assets/icons/Logout.svg";
import QuestionCircle from "../../assets/icons/QuestionCircle.svg";

export const DROPDOWN_MENU = [
  {
    name: "Нэмэлт сан татах",
    icon: QuestionCircle,
    file: "https://food.onispos.mn/files/OnisTpApi.exe",
    isFile: true,
  },
  {
    name: "Гарах",
    logout: true,
    icon: Logout,
  },
];

/* Header */
function OwnHeader(props) {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isOpen, setIsOpenModal] = useState(false);
  const [data, setData] = useState(JSON.parse(localStorage.getItem("auth")));
  const installApp = (e) => {
    e.preventDefault();
    if (promptInstall) {
      promptInstall.prompt();
    } else {
      return;
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler, false);
    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const logout = () => {
    navigate("/login");
    localStorage.removeItem("auth");
    localStorage.removeItem("access_token");
    localStorage.setItem("isshow", "true")
    props.setlogin(false);
  };
  const menus = (
    <Menu>
      {DROPDOWN_MENU.map((item, i) =>
        item.isHead && props._auth && !props._auth.ishead ? null : (
          <Menu.Item key={i}>
            <div className="flex">
              <img
                src={item.icon}
                onClick={() => navigate(item.route)}
                alt=""
                className="w-4 mr-2"
              />
              {item.logout ? (
                <span
                  onClick={() => setIsOpenModal(true)}
                  className="text-black w-full"
                >
                  Гарах
                </span>
              ) : !item.isFile ? (
                <Link to={item.route} className="text-black w-full">
                  {item.name}
                </Link>
              ) : (
                <a className="text-black" href={item.file}>
                  {item.name}
                </a>
              )}
            </div>
          </Menu.Item>
        )
      )}
    </Menu>
  );

  return (
    <header className="bg-headerBack bg-cover w-full px-2 lg:px-6 py-1 flex justify-between items-center">
      <img
        src={logo}
        alt="logo"
        className="w-64 cursor-pointer hidden lg:block -mb-2 rounded-md"
        onClick={() => navigate("/")}
      />
      <img
        src={logow}
        alt="logo"
        className="w-10 cursor-pointer lg:hidden rounded-md"
        onClick={() => navigate("/")}
      />
      <div className="flex items-center">
        {supportsPWA ? (
          <Components.Ripple
            className="glass-btn rounded-2xl"
            onClick={installApp}
          >
            <span>Татах</span>
          </Components.Ripple>
        ) : null}
        <Tooltip
          title={
            props.rescheckService === true
              ? "Service амжилттай холбогдсон байна."
              : "Сервис холбогдоогүй байна."
          }
        >
          <SettingOutlined
            size={50}
            /* spin={props.rescheckService === true} */
            style={{ fontSize: "1rem", color: "#FFF" }}
            className="mr-3 cursor-pointer"
          />
        </Tooltip>
        <div className="bg-[#E9AC22] text-white rounded-lg text-sm absolute px-1.5 top-0 right-0"></div>
        <div className="flex items-center justify-center ml-3">
          <Dropdown
            overlay={menus}
            className="flex items-center"
            trigger={["click"]}
          >
            <div
              className="ant-dropdown-link text-white font-semibold cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <span className="flex items-center">
                {`${data && data.user?.storename} / ${
                  data && data.user?.lastname
                } /`}{" "}
                <DownOutlined className="pl-3" />
              </span>
            </div>
          </Dropdown>
        </div>
      </div>
      <Components.GlobalModal
        footer={[
          <Button onClick={() => setIsOpenModal(false)}>Үгүй</Button>,
          <Button type="primary" onClick={logout} autoFocus>
            Тийм
          </Button>,
        ]}
        width={400}
        isOpen={isOpen}
        onClose={() => setIsOpenModal(false)}
        title="Анхааруулга"
      >
        <div className="py-3 px-10 flex flex-col items-center justify-center">
          <span className="text-center">Та гарахдаа итгэлтэй байна уу?</span>
        </div>
      </Components.GlobalModal>
    </header>
  );
}

export default OwnHeader;
